/**
 * FIN-12062 — General Information party cards (Sender / Partner / Beneficiary)
 * link to the alert's primary detail tab. The target depends on the alert's
 * `type_of_alert` (payload `typeOfAlert`): an activity-driven alert routes to the
 * Activity Information tab, everything else (transaction-driven, the common case)
 * routes to Transaction Information. Returns the SmartAssessment tab key:
 *   "2" = Transaction Information, "3" = Activity Information.
 * Matching is case-insensitive; unknown / missing values default to Transaction.
 */
export const TAB_TRANSACTION = '2';
export const TAB_ACTIVITY = '3';

export const tabKeyForAlertType = (typeOfAlert) => {
  const normalised = String(typeOfAlert ?? '')
    .trim()
    .toLowerCase();
  return normalised === 'activity' ? TAB_ACTIVITY : TAB_TRANSACTION;
};
